import { api } from "api";

export const getProfileGeneral = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/profile/general")
      .then((res) => {
        dispatch({
          type: "GET_PROFILE_GENERAL_SUCCESS",
          payload: res.data.data,
        });

        onSuccess(res.data.data);
      })
      .catch((e) => {
        dispatch({
          type: "GET_PROFILE_GENERAL_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getProfileDetail = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/profile/get")
      .then((res) => {
        dispatch({
          type: "GET_PROFILE_SUCCESS",
          payload: res.data.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_PROFILE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const updateProfile = (profileData, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/profile/update", profileData)
      .then((res) => {
        dispatch({
          type: "UPDATE_PROFILE_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "UPDATE_PROFILE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const updateProfileImage = (image, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();

    let formData = new FormData();
    formData.append("file", image);

    await api
      .post("/api/profile/upload-profile-image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch({
          type: "UPDATE_PROFILEIMAGE_SUCCESS",
          payload: res,
        });

        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "UPDATE_PROFILEIMAGE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const approveKvkk = (kvkkApproveCode, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/profile/kvkk-approve", { kvkkApproveCode: kvkkApproveCode })
      .then((res) => {
        dispatch({
          type: "KVKK_APPROVE_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "KVKK_APPROVE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getMailMatrix = (username, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/profile/get-mail-matris/${username}`)
      .then((res) => {
        console.dir(res);
        dispatch({
          type: "EMAIL_MATRIX_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "EMAIL_MATRIX_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const sendEmailNotification = (
  email,
  mailEmployeeApproveCode,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/profile/send-email-notification`, {
        email: email,
        mailEmployeeApproveCode: mailEmployeeApproveCode,
      })
      .then((res) => {
        console.dir(res);
        dispatch({
          type: "EMAIL_NOTIF_SEND_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "EMAIL_NOTIF_SEND_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const checkEmailCode = (
  code,
  mailEmployeeApproveCode,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/profile/check-email-code`, {
        code: code,
        mailEmployeeApproveCode: mailEmployeeApproveCode,
      })
      .then((res) => {
        console.dir(res);
        dispatch({
          type: "EMAIL_CHECK_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "EMAIL_CHECK_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const sendMobileNotification = (
  cellNumber,
  mobileEmployeeApproveCode,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/profile/send-mobile-notification`, {
        cellNumber: cellNumber,
        mobileEmployeeApproveCode: mobileEmployeeApproveCode,
      })
      .then((res) => {
        console.dir(res);
        dispatch({
          type: "MOBILE_NOTIF_SEND_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "MOBILE_NOTIF_SEND_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const checkMobileCode = (
  code,
  mobileEmployeeApproveCode,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/profile/check-mobile-code`, {
        code: code,
        mobileEmployeeApproveCode: mobileEmployeeApproveCode,
      })
      .then((res) => {
        console.dir(res);
        dispatch({
          type: "MOBILE_CHECK_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "MOBILE_CHECK_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const resetPassword = (username, captchaToken, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/profile/reset-password`, {
        username: username,
      },
        {
          headers: {
            "captcha-token": captchaToken
          }
        })
      .then((res) => {
        console.dir(res);
        dispatch({
          type: "RESET_PASSWORD_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "RESET_PASSWORD_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const saveNewPassword = (
  passwordCode,
  password,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post(`/api/profile/save-new-password`, {
        passwordCode: passwordCode,
        NewPassword: password,
      })
      .then((res) => {
        console.dir(res);
        dispatch({
          type: "SAVE_NEW_PASSWORD_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "SAVE_NEW_PASSWORD_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
